import { Validators } from '@angular/forms';
import {
  CodeMirrorMode,
  CrudFormButtonItem,
  CrudFormCodeMirrorItem,
  CrudFormConfig,
  CrudFormSelectItem,
  CrudViewFormItemType,
  SelectMode
} from '@rappider/rappider-components/utils';
import { CAMEL_CASE_REGEX } from '@rappider/shared/definitions';

export const WORKFLOW_STEP_FUNCTION_CREATE_OR_EDIT_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'SHARED.NAME',
      fieldName: 'name',
      type: CrudViewFormItemType.TextBox,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(CAMEL_CASE_REGEX),
          errorKey: 'pattern',
          errorMessage: 'PROJECT_MODULE.WORKFLOW_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.WORKFLOW_STEP_FUNCTION_NAME_PATTERN_ERROR'
        }
      ]
    },
    {
      title: 'SHARED.TYPE',
      fieldName: 'type',
      type: CrudViewFormItemType.Select,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormSelectItem>
    {
      title: 'PROJECT_MODULE.WORKFLOW_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.SUBSCRIBED_EVENTS',
      fieldName: 'subscribedEvents',
      type: CrudViewFormItemType.Select,
      settings: {
        mode: SelectMode.Multiple
      },
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormSelectItem>
    {
      title: 'PROJECT_MODULE.WORKFLOW_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.PUBLISHED_EVENTS',
      fieldName: 'publishedEvents',
      type: CrudViewFormItemType.Select,
      settings: {
        mode: SelectMode.Multiple
      }
    },
    <CrudFormCodeMirrorItem>
    {
      title: 'PROJECT_MODULE.WORKFLOW_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.CUSTOM_CODE',
      fieldName: 'code',
      type: CrudViewFormItemType.CodeMirror,
      settings: {
        mode: CodeMirrorMode.Javascript,
        autoCloseBrackets: true,
        lineNumbers: true
      }
    }
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    }
  }
};
